import Swiper from 'swiper/bundle';

// import CardsSlider from "./ZoomEffect";
export default class TextImg{

    constructor(el){
        console.log(el);

        this.sliderElement = el.querySelector('.swiper-container');
        this.arrowPrev = el.querySelector('.slider__arrow--prev');
        this.arrowNext = el.querySelector('.slider__arrow--next');
        this.init();
    }

    init(){
        const swiper = new Swiper(this.sliderElement, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
            },
            autoHeight: true,
        });
    }
}